export default __webpack_public_path__ + "static/media/MinejavaEdition.b14bbe23.jpeg";